// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__1Y9dB","marketplaceStroke":"IconEmailAttention_marketplaceStroke__1cLQA","attentionStroke":"IconEmailAttention_attentionStroke__3KoPo"};